import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';

interface SubjectData {
  operationId: string;
  isSuccess: boolean;
  data?: any;
}

@Injectable()
export class OperationTrackerService {
  private static trackerSubject = new Subject<SubjectData>();

  passThroughOperationTracking<T>(operationId: string, input: Observable<T>): Observable<T> {
    return input.pipe(
      tap((data) => OperationTrackerService.trackerSubject.next({ operationId, isSuccess: true, data })),
      catchError((err) => {
        OperationTrackerService.trackerSubject.next({ operationId, isSuccess: false });
        return throwError(err);
      }),
    );
  }

  throwIfOperationIsNotSuccessAsync<TData>(operationId: string): Promise<TData> {
    return firstValueFrom(this.throwIfOperationIsNotSuccess<TData>(operationId));
  }

  private throwIfOperationIsNotSuccess<TData>(operationId: string): Observable<TData> {
    return OperationTrackerService.trackerSubject.pipe(
      filter((tracking) => tracking.operationId === operationId),
      switchMap((tracking) => {
        if (tracking.isSuccess) {
          return of(tracking.data);
        }

        return throwError(new Error(`Operation with id "${operationId}" failed`));
      }),
      take(1),
    );
  }
}
